import { AvatarDropdown, AvatarName, Footer } from '@/components';
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import { PageLoading, ProConfigProvider } from '@ant-design/pro-components';
import { createIntl } from '@ant-design/pro-provider';
import { history } from '@umijs/max';
import 'react-quill/dist/quill.snow.css';
import defaultSettings from '../config/defaultSettings';
import { errorConfig } from './requestErrorConfig';

// Custom Vietnamese locale cho ProComponents
const viVNLocale = {
  moneySymbol: '₫',
  form: {
    lightFilter: {
      more: 'Thêm',
      clear: 'Xóa',
      confirm: 'Xác nhận',
      itemUnit: 'mục',
    },
  },
  tableForm: {
    search: 'Tìm kiếm',
    reset: 'Tải lại',
    submit: 'Gửi',
    collapsed: 'Mở rộng',
    expand: 'Thu gọn',
    inputPlaceholder: 'Vui lòng nhập',
    selectPlaceholder: 'Vui lòng chọn',
  },
  alert: {
    clear: 'Xóa',
    selected: 'Đã chọn',
    item: 'mục',
  },
  pagination: {
    total: {
      range: ' ',
      total: 'trên',
      item: 'mục',
    },
  },
  tableToolBar: {
    leftPin: 'Ghim trái',
    rightPin: 'Ghim phải',
    noPin: 'Bỏ ghim',
    leftFixedTitle: 'Cố định trái',
    rightFixedTitle: 'Cố định phải',
    noFixedTitle: 'Không cố định',
    reset: 'Đặt lại',
    columnDisplay: 'Hiển thị cột',
    columnSetting: 'Cài đặt cột',
    fullScreen: 'Toàn màn hình',
    exitFullScreen: 'Thoát toàn màn hình',
    reload: 'Tải lại',
    density: 'Hiển thị bảng',
    densityDefault: 'Mặc định',
    densityLarger: 'Rộng',
    densityMiddle: 'Trung',
    densitySmall: 'Hẹp',
  },
  stepsForm: {
    next: 'Tiếp theo',
    prev: 'Quay lại',
    submit: 'Hoàn thành',
  },
  loginForm: {
    submitText: 'Đăng nhập',
  },
  editableTable: {
    action: {
      save: 'Lưu',
      cancel: 'Hủy',
      delete: 'Xóa',
      add: 'Thêm dòng mới',
    },
  },
  switch: {
    open: 'Bật',
    close: 'Tắt',
  },
};

const customViVNIntl = createIntl('vi-VN', viVNLocale);

// const isDev = process.env.NODE_ENV === 'development';
const loginPath = '/login';

/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  loading?: boolean;
  loaiVeDtos?: API.LoaiVeDto[];
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
}> {
  const fetchUserInfo = async () => {
    try {
      // const msg = await getUser();
      // return msg?.data;
      return {
        phoneNumber: '0987654321',
        email: 'admin@quangning.vn',
        dateOfBirth: null,
        active: true,
        name: 'Admin',
        roleId: 1,
        roleName: 'Administrator',
        permissions: [],
        id: 1,
        avatar: '',
      };
    } catch (error) {
      history.push(loginPath);
    }
    return undefined;
  };
  // 如果不是登录页面，执行
  const { location } = history;
  if (location.pathname !== loginPath) {
    const response = await fetchUserInfo();
    const currentUser = response;
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: any = ({ initialState }) => {
  return {
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    // waterMarkProps: {
    //   content: initialState?.currentUser?.name,
    // },
    footerRender: () => <Footer />,
    onPageChange: () => {
      // const { location } = history;
      // 如果没有登录，重定向到 login
      // if (!initialState?.currentUser && location.pathname !== loginPath) {
      //   history.push(loginPath);
      // }
    },
    bgLayoutImgList: [],
    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children: any) => {
      if (initialState?.loading) return <PageLoading />;
      return (
        <ProConfigProvider intl={customViVNIntl}>
          {children}
          {/* {isDev && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )} */}
        </ProConfigProvider>
      );
    },
    ...initialState?.settings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  ...errorConfig,
  getResponse: true,
};
